import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { buscarProdutosEstabelecimento, atualizarProdutosEstabelecimento } from '../../services/api';
import { useParams } from 'react-router-dom';
// import { Mask } from 'react-mask';
import Mask from 'react-input-mask';
// css
import 'bootstrap/dist/css/bootstrap.min.css';
import "./PagamentoFinalizado.css";
import '../../styles/global.css';

const PagamentoFinalizado = (dados) => {
    const params = useParams();

    console.log('params recebidos:');
    console.log(params);

    return (
        <div>ok</div>
    );


};

export default PagamentoFinalizado;
